export default __webpack_public_path__ + "static/media/ic_trash_w.bd712b0a.svg";